import { mediasApiUpsellProvider } from "../../../lib/api/providers";

export const fetchMediasApi = ({ token, body }) => {
  return mediasApiUpsellProvider.post(`/`, body).then((response = {}) => {
    return response.data;
  });
};



// WEBPACK FOOTER //
// src/pages/activite/phototheque/api.js